var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom-end", width: "375", trigger: "click" },
      model: {
        value: _vm.popShow,
        callback: function($$v) {
          _vm.popShow = $$v
        },
        expression: "popShow"
      }
    },
    [
      _c(
        "el-button",
        {
          attrs: { slot: "reference", size: "small", plain: "" },
          slot: "reference"
        },
        [
          _c("i", { staticClass: "el-icon-tickets" }),
          _vm._v("\n        Exportar Relatório\n    ")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h5", { staticClass: "font-weight-bold mb-3" }, [
            _vm._v("Relatórios da agenda")
          ]),
          _vm._v(" "),
          _c("el-divider", { staticClass: "mt-3" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "eventExportReport",
              attrs: {
                model: _vm.filters,
                "label-position": "top",
                "status-icon": ""
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "type_report",
                    rules: [
                      {
                        required: true,
                        message: "Selecione o tipo de arquivo para exportação",
                        trigger: "change"
                      }
                    ]
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center",
                      style: { gap: "12px" }
                    },
                    _vm._l(_vm.typesReports, function(typeRepo) {
                      return _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column align-items-center",
                          style: { gap: "12px", cursor: "pointer" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "rounded d-flex justify-content-center align-items-center position-relative",
                              style: {
                                width: "64px",
                                height: "64px",
                                borderWidth: "1px",
                                borderStyle: "solid",
                                borderColor:
                                  typeRepo.name == "XLS"
                                    ? "#c2e7b0"
                                    : "#fbc4c4",
                                backgroundColor:
                                  typeRepo.name == "XLS" ? "#f0f9eb" : "#fef0f0"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chooseAgendaReportUrl(
                                    typeRepo.name
                                  )
                                }
                              }
                            },
                            [
                              typeRepo.name == "XLS"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "bi bi-filetype-xls",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        fill: "#67C23A",
                                        viewBox: "0 0 16 16"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              typeRepo.name == "PDF"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "bi bi-filetype-pdf",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        fill: "#F56C6C",
                                        viewBox: "0 0 16 16"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.type_report != null &&
                              _vm.filters.type_report === typeRepo.name
                                ? _c("span", {
                                    staticClass:
                                      "rounded-circle bg-success position-absolute",
                                    style: {
                                      width: "16px",
                                      height: "16px",
                                      right: "-4px",
                                      top: "-4px"
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h5",
                            { staticClass: "font-weight-bolder text-center" },
                            [_vm._v(_vm._s(typeRepo.name))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "consultant_user_id" } },
                        [
                          _c("label", [_vm._v("Consultor")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                placeholder: "Selecionar consultor",
                                disabled: _vm.isLoading,
                                filterable: ""
                              },
                              model: {
                                value: _vm.filters.consultant_user_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filters,
                                    "consultant_user_id",
                                    $$v
                                  )
                                },
                                expression: "filters.consultant_user_id"
                              }
                            },
                            _vm._l(_vm.sales, function(sale) {
                              return _c("el-option", {
                                key: sale.user_id,
                                staticClass: "text-truncate",
                                attrs: { value: sale.user_id, label: sale.text }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "status" } },
                        [
                          _c("label", [_vm._v("Status")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                placeholder: "Selecionar status",
                                filterable: ""
                              },
                              model: {
                                value: _vm.filters.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.filters, "status", $$v)
                                },
                                expression: "filters.status"
                              }
                            },
                            [
                              _c("el-option", { attrs: { value: null } }, [
                                _vm._v("Todos")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.status, function(stat) {
                                return _c(
                                  "el-option",
                                  {
                                    key: stat.value,
                                    attrs: { value: stat.value }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        stat.value != null
                                          ? _c("el-tag", {
                                              staticClass:
                                                "rounded-circle mr-2",
                                              style: { width: "20px" },
                                              attrs: {
                                                type: _vm.getEventColorByStatus(
                                                  stat.value
                                                ),
                                                size: "mini"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(stat.text) +
                                            "\n                                "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "periodo",
                            rules: [
                              {
                                required: true,
                                message: "O período é obrigatório",
                                trigger: "change"
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Período")]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            attrs: {
                              "unlink-panels": "",
                              size: "small",
                              type: "daterange",
                              "start-placeholder": "Inicio",
                              "end-placeholder": "Fim",
                              format: "dd/MM/yyyy",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filters.periodo,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "periodo", $$v)
                              },
                              expression: "filters.periodo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type:
                                this.filters.type_report == "XLS"
                                  ? "success"
                                  : this.filters.type_report == "PDF"
                                  ? "danger"
                                  : "primary",
                              plain: "",
                              disabled: _vm.isLoading
                            },
                            on: { click: _vm.exportReport }
                          },
                          [
                            _c("i", { staticClass: "el-icon-tickets" }),
                            _vm._v(" "),
                            this.filters.type_report == "XLS"
                              ? _c("span", [_vm._v("Gerar relátorio")])
                              : this.filters.type_report == "PDF"
                              ? _c("span", [_vm._v("Gerar PDF")])
                              : _c("span", [_vm._v("Gerar")])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fda04ff4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fda04ff4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsExportReports.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-fda04ff4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsExportReports.vue
// module chunks = 2